export const tr = {
    'button-cancel': 'İptal',
    'button-submit': 'Uygula'
};
